import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../../assets/style/BranchForm.css"; // Updated CSS file with USWDS grid
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import { toast } from "react-toastify";

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  branch_name: Yup.string().required("Branch name is required"),
  street_1: Yup.string().required("Street 1 is required"),
  country: Yup.string().required("Country is required"),
  state: Yup.string().required("State is required"),
  city: Yup.string().required("City is required"),
  zipcode: Yup.string().required("Zipcode is required"),
});

const BranchForm = ({ onClose, id, fetchData }) => {
  console.log("id", id);
  const countryList = [
    { label: "India", value: "in" },
    { label: "USA", value: "us" },
  ];

  const [singleData, setSingleData] = useState();
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");

  const singleCountyData = async () => {
    try {
      const result = await getData(`/api/get-branch/${id}`);
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message); 
      }
    } catch (error) {
      toast.error("Something went wrong.");
    }
  };

  const handleSubmit = async (values) => {
    try {
      const request_url = id
        ? `/api/update-branch/${id}`
        : "/api/create-branch";
      const postDataResult = await postData(request_url, values);

      toast.success(postDataResult.message);

      onClose();
      fetchData();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Submission failed.");
    }
  };

  useEffect(() => {
    id && singleCountyData();
  }, [id]);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          branch_name: id ? singleData?.branch_name : "",
          street_1: id ? singleData?.street_1 : "",
          street_2: id ? singleData?.street_2 : "",
          country: id ? singleData?.country : "",
          state: id ? singleData?.state : "",
          city: id ? singleData?.city : "",
          zipcode: id ? singleData?.zipcode : "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="form-body">
           

              <div className="grid-row">
                <div className="grid-col-12">
                  <div className="form-group">
                    <label htmlFor="branch_name">Branch Name</label>
                    <Field
                      id="branch_name"
                      name="branch_name"
                      type="text"
                      placeholder="Enter branch name"
                      className={
                        errors.branch_name && touched.branch_name
                          ? "input-error"
                          : ""
                      }
                    />
                    <ErrorMessage
                      name="branch_name"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>
              </div>

              <div className="grid-row">
                <div className="grid-col-12">
                  <div className="form-group">
                    <label htmlFor="street_1">Street 1</label>
                    <Field
                      id="street_1"
                      name="street_1"
                      type="text"
                      placeholder="Enter street address"
                      className={
                        errors.street_1 && touched.street_1 ? "input-error" : ""
                      }
                    />
                    <ErrorMessage
                      name="street_1"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>
              </div>

              <div className="grid-row">
                <div className="grid-col-12">
                  <div className="form-group">
                    <label htmlFor="street_2">Street 2</label>
                    <Field
                      id="street_2"
                      name="street_2"
                      type="text"
                      placeholder="Additional address information (optional)"
                    />
                  </div>
                </div>
              </div>

              <div className="grid-row">
                <div className="grid-col-6">
                  <div className="form-group">
                    <label htmlFor="city">City</label>
                    <Field
                      id="city"
                      name="city"
                      type="text"
                      placeholder="Enter city"
                      className={
                        errors.city && touched.city ? "input-error" : ""
                      }
                    />
                    <ErrorMessage
                      name="city"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>

                <div className="grid-col-6">
                  <div className="form-group">
                    <label htmlFor="country">Country</label>
                    <Field
                      name="country"
                      component={CustomSelect}
                      options={countryList}
                      placeholder="Select country"
                    />
                    <ErrorMessage
                      name="country"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>
              </div>

              <div className="grid-row">
                <div className="grid-col-6">
                  <div className="form-group">
                    <label htmlFor="state">State</label>
                    <Field
                      id="state"
                      name="state"
                      type="text"
                      placeholder="Enter state"
                      className={
                        errors.state && touched.state ? "input-error" : ""
                      }
                    />
                    <ErrorMessage
                      name="state"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>

                <div className="grid-col-6">
                  <div className="form-group">
                    <label htmlFor="zipcode">Zipcode</label>
                    <Field
                      id="zipcode"
                      name="zipcode"
                      type="text"
                      placeholder="Enter zipcode (e.g. 12345 or 12345-6789)"
                      className={
                        errors.zipcode && touched.zipcode ? "input-error" : ""
                      }
                    />
                    <ErrorMessage
                      name="zipcode"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-footer">
              <button
                type="button"
                className="btn btn-cancel"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default BranchForm;
